<template>
  <div>
    <GmapMap
      :center="formOkBoy.coordenadasMap"
      :zoom="17"
      map-type-id="terrain"
      style="width: 100%; height: 300px"
      ref="mapRef"
      :options="{
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      }"
    >
      <GmapMarker
        :position="formOkBoy.coordenadasMap"
        :clickable="false"
        :draggable="false"
      ></GmapMarker>
    </GmapMap>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["formOkBoy"]),
  }, 
   
};
</script>

<style scoped>
</style>